(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var DESKTOP_GAP = 16;
  var MOBILE_GAP = 16;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getSlideCount(root) {
    var count = parseInt(root.getAttribute('data-slide-count') || '0', 10);
    return Number.isFinite(count) ? count : 0;
  }

  function buildConfig(root) {
    var slideCount = getSlideCount(root);
    var mobile = isMobile();

    return {
      slidesPerView: mobile ? 1 : 2,
      spaceBetween: mobile ? MOBILE_GAP : DESKTOP_GAP,
      loop: slideCount > (mobile ? 1 : 2),
      speed: 450,
      watchOverflow: true,
      navigation: {
        nextEl: root.querySelector('.melbourne-marathon-2026-run__nav-btn--next'),
        prevEl: root.querySelector('.melbourne-marathon-2026-run__nav-btn--prev')
      }
    };
  }

  function MelbourneMarathon2026Run(root) {
    this.root = root;
    this.swiper = null;
    this.mediaQuery = window.matchMedia(MOBILE_QUERY);
    this.onMediaChange = this.handleMediaChange.bind(this);
    this.createSwiper();

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.onMediaChange);
    } else {
      this.mediaQuery.addListener(this.onMediaChange);
    }
  }

  MelbourneMarathon2026Run.prototype.createSwiper = function () {
    if (typeof Swiper === 'undefined') return;

    var swiperEl = this.root.querySelector('.melbourne-marathon-2026-run__swiper');
    if (!swiperEl || getSlideCount(this.root) === 0) return;

    this.swiper = new Swiper(swiperEl, buildConfig(this.root));
  };

  MelbourneMarathon2026Run.prototype.handleMediaChange = function () {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.createSwiper();
  };

  function observeModuleImpression(root) {
    if (!root || root.dataset.mm2026RunImpressionInit === 'true') return;
    root.dataset.mm2026RunImpressionInit = 'true';

    function push() {
      if (root.dataset.mm2026RunImpression === 'true') return;
      root.dataset.mm2026RunImpression = 'true';
      var moduleName = root.getAttribute('data-ga4-module') || 'ugc';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'module_impression',
        event_parameters: {
          module: moduleName
        }
      });
    }

    if (!('IntersectionObserver' in window)) {
      push();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          push();
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    io.observe(root);
  }

  function pushSelectContent(contentName, buttonName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: 'ugc',
        content_name: contentName,
        button_name: buttonName || ''
      }
    });
  }

  function bindSelectContentButton(root, selector, flag, contentName) {
    if (!root || root.dataset[flag] === 'true') return;
    var button = root.querySelector(selector);
    if (!button) return;

    root.dataset[flag] = 'true';
    button.addEventListener('click', function () {
      pushSelectContent(contentName, (button.textContent || '').trim());
    });
  }

  function bootAll() {
    document.querySelectorAll('.melbourne-marathon-2026-run').forEach(function (el) {
      observeModuleImpression(el);
      bindSelectContentButton(el, '.melbourne-marathon-2026-run__btn--join', 'mm2026RunJoinGa4', 'signup');
      bindSelectContentButton(el, '.melbourne-marathon-2026-run__btn--share', 'mm2026RunShareGa4', 'social_media');
    });

    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', bootAll, { once: true });
      return;
    }

    document.querySelectorAll('.melbourne-marathon-2026-run').forEach(function (el) {
      if (el._mm2026Run) return;
      el._mm2026Run = new MelbourneMarathon2026Run(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
